"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPermission = void 0;
/**
 * 表单权限
 */
var FormPermission;
(function (FormPermission) {
    FormPermission[FormPermission["LOGIN"] = 0] = "LOGIN";
    FormPermission[FormPermission["NO_LOGIN"] = 1] = "NO_LOGIN";
    FormPermission[FormPermission["WORKSPACE"] = 2] = "WORKSPACE";
    FormPermission[FormPermission["INVITE"] = 3] = "INVITE";
})(FormPermission = exports.FormPermission || (exports.FormPermission = {}));
